import AnnualLeasingAmountError from './AnnualLeasingAmountError';
class AnnuaLeasingCannotBeLessThanOne extends AnnualLeasingAmountError {
    constructor(options) {
        super('ANUUAL_LEASING_CANNOT_BE_LESS_THAN_ONE', options);
    }
}
export default AnnuaLeasingCannotBeLessThanOne;
